import {
  REQUEST_INSURANCECUSTOMER_GET_CASENFO,
  RESPONSE_INSURANCECUSTOMER_GET_CASENFO,
  ERROR_INSURANCECUSTOMER_GET_CASENFO,

  REQUEST_ADD_CUSTOMER_ACTION,
  SUCCESS_ADD_CUSTOMER_ACTION,
  ERROR_ADD_CUSTOMER_ACTION,

  REQUEST_GET_CUSTOMER_ACTIONS,
  SUCCESS_GET_CUSTOMER_ACTIONS,
  ERROR_GET_CUSTOMER_ACTIONS,

  REQUEST_CUSTOMER_SCORECARD,
  RECEIVE_CUSTOMER_SCORECARD,
  ERROR_CUSTOMER_SCORECARD,

  REQUEST_ALL_CUSTOMER_ACTIONS_FOR_USER,
  RECEIVE_ALL_CUSTOMER_ACTIONS_FOR_USER,
  ERROR_ALL_CUSTOMER_ACTIONS_FOR_USER,
} from "typeConstants";

import { homeownerCustomer as initialState } from "reducers/initialState.tsx";

// Customer (underwriter) actions should get moved to its own reducer

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_INSURANCECUSTOMER_GET_CASENFO:
      return {
        ...state,
        caseInfo: null
      };
    case RESPONSE_INSURANCECUSTOMER_GET_CASENFO:
      return {
        ...state,
        caseInfo: action.payload
      };
    case ERROR_INSURANCECUSTOMER_GET_CASENFO:
      return {
        ...state,
        caseInfo: null
      };
    case REQUEST_ADD_CUSTOMER_ACTION:
    case SUCCESS_ADD_CUSTOMER_ACTION:
    case ERROR_ADD_CUSTOMER_ACTION:
      return state;
    case REQUEST_GET_CUSTOMER_ACTIONS:
      return state;
    case SUCCESS_GET_CUSTOMER_ACTIONS:
      return {
        ...state,
        caseInfo: {
          ...state.caseInfo,
          underwriterActionsAudits: action.payload,
        }
      };
    case ERROR_GET_CUSTOMER_ACTIONS:
      return state;
    case REQUEST_CUSTOMER_SCORECARD:
      return state;
    case RECEIVE_CUSTOMER_SCORECARD:
      return {
        ...state,
        customerScorecardData: action.payload,
      };
    case ERROR_CUSTOMER_SCORECARD:
      return state;
    case REQUEST_ALL_CUSTOMER_ACTIONS_FOR_USER:
      return {
        ...state,
        fetchingAllCustomerActionsForUser: true,
      };
    case RECEIVE_ALL_CUSTOMER_ACTIONS_FOR_USER:
      return {
        ...state,
        fetchingAllCustomerActionsForUser: false,
        allCustomerActionsForUser: action.payload,
      };
    case ERROR_ALL_CUSTOMER_ACTIONS_FOR_USER:
      return {
        ...state,
        fetchingAllCustomerActionsForUser: false,
      };
    default:
      return state;
  }
};

export default reducer;